import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pacientes-quirurgicos',
  templateUrl: './pacientes-quirurgicos.component.html',
  styleUrls: ['./pacientes-quirurgicos.component.css']
})
export class PacientesQuirurgicosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
